import {Carousel} from 'bootstrap';
import 'slick-carousel';
import 'simple-parallax-js';
import AOS from 'aos';

export default {
	mounted() {
		setTimeout(function(){ 
			AOS.init({
				// Global settings:
				disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
				startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
				initClassName: 'aos-init', // class applied after initialization
				animatedClassName: 'aos-animate', // class applied on animation
				useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
				disableMutationObserver: false, // disables automatic mutations' detections (advanced)
				debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
				throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
				
				// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
				offset: 320, // offset (in px) from the original trigger point
				delay: 0, // values from 0 to 3000, with step 50ms
				duration: 400, // values from 0 to 3000, with step 50ms
				easing: 'ease', // default easing for AOS animations
				once: true, // whether animation should happen only once - while scrolling down
				mirror: false, // whether elements should animate out while scrolling past them
				anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
			});
	}, 1000);
		$('.js-slider').each(function () {
			const $this = $(this);
			const options = {
				centerMode: true,
				centerPadding: '8%',
				slidesToShow: 1,
				init: true,
				nextArrow: '<div class="btn--arrow"></div>',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							arrows: false,
							centerMode: true,
							centerPadding: '40px',
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 480,
						settings: {
							arrows: true,
							centerMode: true,
							centerPadding: '20px',
							slidesToShow: 1,
						},
					},
				],
				...$this.data(),
			};
	
			$this.slick(options);
		});
	
		var prevScrollpos = window.pageYOffset;
		$('body').addClass('nav--show');
		window.onscroll = function() {
			var st = $(this).scrollTop();
			var currentScrollPos = window.pageYOffset;
	
			if (prevScrollpos > currentScrollPos || currentScrollPos == 0) {
				if(currentScrollPos < 700) {
					$('body').addClass('nav--show');
					$('body').removeClass('nav--dark');
				} else {
					$('body').addClass('nav--show nav--dark');
				}
			} else {
				if(currentScrollPos > 500) {
					$('body').removeClass('nav--show nav--dark');
				}
			}
	
			prevScrollpos = currentScrollPos;
		}
	
		$('.cd-image-container').each(function(){
			var actual = $(this);
			drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual);
		});
		
		// Enlever le header si un parametre est dans l'url
		let params = new URLSearchParams(location.search);
		var url = params.get('tab');
		if($(url) && url == 'h3_sport' || url == 'h3_open_air' || url == 'd3_uav_plateform' || url == 'ua3_helidrone') {
			$('body').addClass('hide_header');
		}
	
		var sections = document.querySelectorAll('.contenu');
		var navLink = document.querySelectorAll('.nav--helicopter a');
	
		$('.nav--helicopter').on('click', 'a' ,function(e) {
			e.preventDefault();
			let href = $(this).attr('href');
			$('.js-slider').slick('refresh');
			// $(window).scrollTop(280);
			if(href.slice(1) == 'h3_sport' || href.slice(1) == 'h3_open_air' || href.slice(1) == 'd3_uav_plateform' || href.slice(1) == 'ua3_helidrone') {
				$('body').addClass('hide_header');
			} else {
				$('body').removeClass('hide_header');
			}
			for (let index = 0; index < navLink.length; index++) {
				navLink[index].classList.remove('actif');
			}
			$(this).addClass('actif');
			for (let index = 0; index < sections.length; index++) {
				if(sections[index].id == href.slice(1)) {
					sections[index].classList.add('show');
					setTimeout(function() {
						sections[index].classList.add('ready');
					}, 100);
				} else {
					sections[index].classList.remove('ready');
					sections[index].classList.remove('show');
				}
			}
		});
		window.addEventListener('resize', function(event){
			resizePictures();
		});
		resizePictures();
		$('.news__filter').on('click', '.btn' ,function(e) {
			e.preventDefault();
	
			let href = $(this).find('a').attr('href');
		 
			$('.news__filter .btn').each(function() {
				if($(this).hasClass('actif')) {
					$(this).removeClass('actif');
				}
			});
			$(this).addClass('actif');
			$.ajax(href)
					.done(function(data) {
						//get next article and push at the end
						$('.news__container').html('');
						let targetArticle = $(data).find('.news__container').html();
						$('.news__container').append( targetArticle );          
					})
					.fail(function(jqxhr) {
							alert(jqxhr.responseText);
					});
		});
	
		$('.pagination_actualites').on('click', 'a', function(e) {
			e.preventDefault();
			let href = $(this).attr('href');
			$(".section--news").animate({ scrollTop: 0 }, "slow");
			$.ajax(href)
					.done(function(data) {
						//get next article and push at the end
						let targetArticle = $(data).find('.news__container').html();
						$('.news__container').html('');
						$('.news__container').append( targetArticle );          
				})
				.fail(function(jqxhr) {
						alert(jqxhr.responseText);
				});
		});
		// var myCarousel = document.querySelector('#carouselExampleControls')
		// var carousel = new Carousel(myCarousel, {
		// 	interval: 2000,
		// 	wrap: false,
		// });

		$('.nav__burger').on('click' ,function() {
			$(document.body).toggleClass('nav-open');
		});

		$( document ).ready(function() {      
			var is_mobile = false;
	
			if( $('#some-element').css('display')=='none') {
					is_mobile = true;       
			}
	
			// now I can use is_mobile to run javascript conditionally
	
			if (is_mobile == true) {
					//Conditional script here
			}
	 });

	 $(function() {      
			let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

			if (isMobile) {
					//Conditional script here
					$('.menu-item-has-children > a').on('click',function(e) {
						// if(!$(this).hasClass('menu--open')) {
						// 	e.stopPropagation();
						// 	e.preventDefault();
						// }
						$(this).toggleClass('open');
      			e.preventDefault();

					});
			}
	});

		

		// $( ".menu-item-has-children" )
		// .mouseenter(function() {
		// 	console.log('enbter')

		// })
		// .mouseleave(function() {
		// 	console.log('ter')
		// });

	},
	
};


function resizePictures(){
  let pictures = document.querySelectorAll(".img--carre");
  if (pictures.length != 0) {
    
    for(let i = 1; i <= pictures.length; i++){
        let picturesWidth = pictures[i - 1];
        let widthPictures = picturesWidth.clientWidth;
          if ((i - 1) == pictures.length) {
              pictures[i].style.height = widthPictures+"px";
          }else {
              pictures[i - 1].style.height = widthPictures+"px";
          }
      }
  }
}


function drags(dragElement, resizeElement, container) {
  dragElement.on("mousedown vmousedown", function(e) {
     dragElement.addClass('draggable');
     resizeElement.addClass('resizable');

     var dragWidth = dragElement.outerWidth(),
         xPosition = dragElement.offset().left + dragWidth - e.pageX,
         containerOffset = container.offset().left,
         containerWidth = container.outerWidth(),
         minLeft = containerOffset + 10,
         maxLeft = containerOffset + containerWidth - dragWidth - 10;
       
     dragElement.parents().on("mousemove vmousemove", function(e) {
        let leftValue = e.pageX + xPosition - dragWidth;
           
        //constrain the draggable element to move inside its container
        if(leftValue < minLeft ) {
           leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
           leftValue = maxLeft;
        }

        let widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';

        $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
           $(this).removeClass('draggable');
           resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue); 

        //function to upadate images label visibility here
        // ...

     }).on("mouseup vmouseup", function(e){
        dragElement.removeClass('draggable');
        resizeElement.removeClass('resizable');
     });
     e.preventDefault();
  }).on("mouseup vmouseup", function(e) {
     dragElement.removeClass('draggable');
     resizeElement.removeClass('resizable');
  });






}